module.exports = __webpack_public_path__ + "static/media/programRequests.b3b06793.svg";